<template>
  <vs-select
    class="w-full mt-3"
    label="Category"
    v-model="selected"
    autocomplete
  >

    <vs-select-item
      :key="index"
      :value="item"
      :text="item.nameId"
      v-for="(item,index) in arrayData"
    />

  </vs-select>
</template>

<script>
import store from '@/store/store'

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          id: '',
        }
      }
    }
  },
  data () {
    return { store }
  },
  computed: {
    arrayData: {
      get () {
        return this.store.getters['category/arrayParent']
      }
    },
    selected: {
      get () {
        return this._.get(this.data, 'nameId', '')
      },
      set (val) {
        this.$emit('change', {
          id: val.id,
          nameId: val.nameId,
          nameEn: val.nameEn,
          iconUrl: val.iconUrl,
          backgroundColor: val.backgroundColor || '',
        })
      }
    }
  }
}
</script>
